enum ChargingConnectorPlug {
    PLUGGED_ON = 'rioglyph-plugged-on',
    PLUGGED_OFF = 'rioglyph-plugged-off',
}

export default ChargingConnectorPlug;
